export enum LicenseCodename {
    demo = 'demo',
    pro = 'pro',
    personal = 'personal',
    business = 'business',
    developer = 'developer',
    business2020 = 'business2020',
    businessPlus = 'business-plus',
    businessPlus2020 = 'business-plus-2020',
    enterprise = 'enterprise',
    reseller = 'reseller',
}
